
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateExpensePaymentMethodDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    offsetLedgerAccountId: new FormControl<number | undefined>(undefined),
    createsOpenItem: new FormControl<boolean | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
    sortOrder: new FormControl<number | undefined>(undefined),
})
;
}
      